// Libs
import React from "react";
import { Helmet } from "react-helmet";

// Components
import { AppHeader } from "./components/App";
import { Routes } from "./pages";
import { ErrorModal } from "./features/ErrorModal";
import { AppFrame } from "./components/App/AppFrame";
import { Providers } from "./Providers";
import { AppGate } from "./components/App/AppGate";

const App: React.FC = () => {
  return (
    <Providers>
      <Helmet
        titleTemplate="%s - Gentrack Cloud"
        defaultTitle="Billing & Operations - Gentrack Cloud"
      />
      <AppFrame>
        <ErrorModal />
        <AppHeader />
        <AppGate>
          <Routes />
        </AppGate>
      </AppFrame>
    </Providers>
  );
};

export default App;
